import { alpha, Box, Paper, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { fileData } from "src/components/file-thumbnail";
import { fData } from "src/utils/formatNumber";

RejectionFiles.propTypes = {
  fileRejections: PropTypes.array,
};

const formatFileSize = (sizeInBytes) => {
  if (sizeInBytes >= 1024 * 1024 * 1024) {
    return `${(sizeInBytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  } else if (sizeInBytes >= 1024 * 1024) {
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
  } else if (sizeInBytes >= 1024) {
    return `${(sizeInBytes / 1024).toFixed(2)} KB`;
  } else {
    return `${sizeInBytes} bytes`;
  }
};

export default function RejectionFiles({ fileRejections, maxFiles, maxSize }) {
  if (!fileRejections.length && fileRejections.length === 0) {
    return null;
  }

  const verifyError = (code, message) => {
    switch (code) {
      case "file-invalid-type":
        return `El tipo de archivo debe ser ${message.slice(18)}`;
      case "file-too-large":
        return `El archivo es demasiado grande. Máximo ${formatFileSize(
          maxSize,
        )}`;
      case "too-many-files":
        return `Se ha excedido el límite de carga. Solo es posible cargar un máximo de ${maxFiles} archivos a la vez.`;
      default:
        break;
    }
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        py: 1,
        px: 2,
        mt: 3,
        bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
        borderColor: (theme) => alpha(theme.palette.error.main, 0.24),
      }}
    >
      {fileRejections.map(({ file, errors }) => {
        const { path, size } = fileData(file);
        return (
          <Box key={path} sx={{ my: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {path} - {size ? fData(size) : ""}
            </Typography>

            {errors.map((error) => (
              <Box
                key={error.code}
                component="span"
                sx={{ typography: "caption" }}
              >
                - {verifyError(error.code, error.message)}
              </Box>
            ))}
          </Box>
        );
      })}
    </Paper>
  );
}
